<template>
    <div class="flex items-center">
        <ActionLink
            :url="url"
            icon="download"
            v-if="exportLink"
            @action-button-click="exportData"
        >
            Export
        </ActionLink>
        <ActionButton
            v-if="postcardLink"
            dusk="postcard-button"
            icon="download"
            class="border-r-none rounded-r-none"
            @action-button-click="exportPostcards"
        >Download Postcards</ActionButton>
        <ActionButton
            v-if="!exportLink"
            dusk="export-button"
            :class="{
                'border-l-0 rounded-l-none': postcardLink,
                'rounded-r-none': shareable,
            }"
            icon="download"
            @action-button-click="exportData"
        >
            Export CSV
        </ActionButton>
        <CopyAction
            v-if="shareable"
            icon="share"
            class="border border-blue-500 rounded-l-none border-l-0 text-blue-600"
            label="Copy shareable link"
            :value="shareUrl"
        />
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "DataExport",
    props: {
        exportLink: Boolean,
        postcardLink: Boolean,
        filename: String,
        shareable: Boolean,
        url: {
            type: String,
            required: true,
        },
        shareUrl: {
            type: String,
            required: false,
        },
        postcardExportUrl: {
            type: String,
            required: false,
        },
        batchId: {
            type: Number,
            required: false
        }
    },
    methods: {
        exportData() {
            // @ts-ignore
            this.$events.$emit("toastNotification", {
                heading: "Exporting data. Please wait...",
            });

            if (!this.exportLink) {
                fetch(this.url)
                    .then(res => res.json())
                    .then((json) => {
                        this.$events.$emit("toastNotification", {
                            action: "saved",
                            heading: "Data export succeeded! You'll receive an email shortly with a link to the export. This may take 2-3 minutes.",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        // @ts-ignore
                        this.$events.$emit("toastNotification", {
                            action: "error",
                            heading: "Data export failed!",
                            status: "error",
                        });
                    });
            }
        },
        exportPostcards() {
            // @ts-ignore
            this.$events.$emit("toastNotification", {
                heading: "Exporting postcards. Please wait...",
            });

            if (this.postcardExportUrl) {
                fetch(this.postcardExportUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": (document.querySelector('meta[name="token"]') as HTMLMetaElement)?.content,
                    },
                    body: JSON.stringify({batch_id: this.batchId}),
                })
                    .then(res => res.json())
                    .then((json) => {
                        this.$events.$emit("toastNotification", {
                            action: "saved",
                            heading: "Postcard export succeeded! You'll receive an email shortly with a link to the export. This may take 2-3 minutes.",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        console.error(`Error posting to postcard export endpoint`, error)
                        // @ts-ignore
                        this.$events.$emit("toastNotification", {
                            action: "error",
                            heading: "Postcard export failed!",
                            status: "error",
                        });
                    });
            }
        }
    }
});
</script>
